import React from 'react'
import styled from 'styled-components'
import { ensureFormulaSuffix } from 'utility'

const Shell = styled.div`
    margin-top: 8px;
    max-width: 420px;
`

const ValueRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 42px;
    padding: 8px 12px;
    border-radius: 10px;
    background: #f4f7fb;
    border: 1px solid #d5deea;
`

const FxMark = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 28px;
    height: 22px;
    padding: 0 6px;
    border-radius: 999px;
    background: #e8eefc;
    color: #2841a1;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.02em;
`

const Value = styled.span`
    font-size: 1.05rem;
    font-weight: 650;
    color: #1f2937;
    letter-spacing: 0.01em;
`

const Hint = styled.div`
    margin-left: auto;
    color: #9a6700;
    font-size: 0.86rem;
    text-align: right;
`

export const FormulaResult = ({ question }) => {
    const suffix = question?.Formula?.Suffix || question?.Formula?.suffix
    const serverDisplay = question?.FormulaDisplay
    const stored = question?.Answers?.SingleResponse?.Response
    const plain =
        (serverDisplay && String(serverDisplay).trim()) ||
        (stored != null ? String(stored).trim() : '')
    const display = ensureFormulaSuffix(plain, suffix)
    const message = question?.FormulaMessage
    const hasValue = display !== ''

    return (
        <Shell>
            <ValueRow>
                <FxMark>fx</FxMark>
                <Value>{hasValue ? display : '—'}</Value>
                {!hasValue && message ? <Hint>{message}</Hint> : null}
            </ValueRow>
        </Shell>
    )
}
